<template>
  <div class="time-wrapper">{{data}}</div>
</template>
<script>
export default {
  data() {
    return {
      data: ''
    }
  },
  props: ['value'],
  watch: {
    value: {
      handler() {
        this.data = typeof this.value === 'string' ? this.value : this.timestampToData(this.value)
      }
    }
  },
  methods: {
    timestampToData(timestamp) {
      function formatDate(now) {
        var year = now.getFullYear()
        var month = (now.getMonth() + 1).toString().padStart(2, '0')
        var date = now.getDate().toString().padStart(2, '0')
        var hour = now.getHours().toString().padStart(2, '0')
        var minute = now.getMinutes().toString().padStart(2, '0')
        var second = now.getSeconds().toString().padStart(2, '0')
        return (
          year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        )
      }
      return formatDate(new Date(timestamp))
    }
  },
  created() {
    if (this.value) {
      this.data = typeof this.value === 'string' ? this.value : this.timestampToData(this.value)
    } else {
      this.data = ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.time-wrapper
  text-overflow ellipsis
  white-space pre
  overflow hidden
</style>
